<template>
<div>
  <!-- <label>关键词：<input v-model="keyword"></label>
  <label>地区：<input v-model="location"></label>
  <baidu-map class="map">
    <bm-view class="map"></bm-view>
    <bm-local-search :keyword="keyword" :auto-viewport="true" :location="location"></bm-local-search>
  </baidu-map> -->
  <div id="main2" style="width:800px;height:600px;"></div>
  <div id="main" style="width:800px;height:600px;"></div>
  </div>
</template>

<script>
import * as echarts from 'echarts';
export default {
  mounted(){

    var chartDom = document.getElementById('main2');
var myChart = echarts.init(chartDom);
var option;

var hours = ['空调', '风扇', '微波炉', ];
var days = [
    {
      
    }
  ]
// ['00:00', '06:00', '12:00','18:00', '24:00'];
var data = [
  {
    name:'hahah',
    value:1,
    label:{
      show:true,
    }

  }
]
// [[0,0,5],[0,1,7],[0,3,7],[1,0,7,]]

// data = data.map(function (item) {
//     return [item[1], item[0], item[2] || '-'];
// });

option = {
    tooltip: {
        position: 'top'
    },
    grid: {
        height: '50%',
        top: '10%'
    },
    xAxis: {
        type: 'category',
        data: hours,
        splitArea: {
            show: true
        },
        axisLine:{
            show:false
        },
        axisTick:{
            show:false,
            alignWithLabel:true,
            interval:5,
        },
    },
    yAxis: {
        type: 'time',
        boundaryGap:true,
        data: days,
         gridIndex:0,
        axisLine:{
            show:false
        },
        axisTick:{
            show:false,
            alignWithLabel:false,
             interval:5,
        },
        splitArea: {
            show: true
        }
    },
    // visualMap: {
    //     type:'continuous',
    //     min: 0,
    //     max: 10,
    //     color:"red",
    //     calculable: false,
    //     orient: 'horizontal',
    //     left: 'center',
    //     top: '0'
    // },
    series: [{
        name: 'test',
        type: 'bar',
        data: data,
        label: {
            show: true
        },
        // emphasis: {
        //     itemStyle: {
        //         shadowBlur: 10,
        //         shadowColor: 'rgba(0, 0, 0, 0.5)'
        //     }
        // },
        showBackground: true,
         backgroundStyle:true,
         backgroundStyle:{
            backgroundColor:'rgba(238, 238, 238, 1)',
            // color:'#f00'
         },
         label:{
           show:true,
         },
        itemStyle: {
            // color: new echarts.graphic.LinearGradient(
            //     0, 0, 0, 1,
            //     [
            //         {offset: 0, color: '#83bff6'},
            //         {offset: 0.5, color: '#188df0'},
            //         {offset: 1, color: '#188df0'}
            //     ]
            // )
        },
            // emphasis: {
            //     itemStyle: {
            //         color: new echarts.graphic.LinearGradient(
            //             0, 0, 0, 1,
            //             [
            //                 {offset: 0, color: '#2378f7'},
            //                 {offset: 0.7, color: '#2378f7'},
            //                 {offset: 1, color: '#83bff6'}
            //             ]
            //         )
            //     }
            // },
    }]
};

option && myChart.setOption(option);

//     var chartDom = document.getElementById('main');
// var myChart = echarts.init(chartDom);
// var option;

// var dataAxis = ['点', '击', '柱', '子', '或', '者', '两', '指', '在', '触', '屏', '上', '滑', '动', '能', '够', '自', '动', '缩', '放'];
// var data = [220, 182, 191, 234, 290, 330, 310, 123, 442, 321, 90, 149, 210, 122, 133, 334, 198, 123, 125, 220];
// var yMax = 500;
// var dataShadow = [];

// for (var i = 0; i < data.length; i++) {
//     dataShadow.push(yMax);
// }

// option = {
//     title: {
//         text: '特性示例：渐变色 阴影 点击缩放',
//         subtext: 'Feature Sample: Gradient Color, Shadow, Click Zoom'
//     },
//     xAxis: {
//         data: dataAxis,
//         axisLabel: {
//             inside: true,
//             textStyle: {
//                 color: '#fff'
//             }
//         },
//         axisTick: {
//             show: false
//         },
//         axisLine: {
//             show: false
//         },
//         z: 10
//     },
//     yAxis: {
//         axisLine: {
//             show: false
//         },
//         axisTick: {
//             show: false
//         },
//         axisLabel: {
//             textStyle: {
//                 color: '#999'
//             }
//         }
//     },
//     dataZoom: [
//         {
//             type: 'inside'
//         }
//     ],
//     series: [
//         {
//             type: 'bar',
//             showBackground: true,
//             itemStyle: {
//                 color: new echarts.graphic.LinearGradient(
//                     0, 0, 0, 1,
//                     [
//                         {offset: 0, color: '#83bff6'},
//                         {offset: 0.5, color: '#188df0'},
//                         {offset: 1, color: '#188df0'}
//                     ]
//                 )
//             },
//             emphasis: {
//                 itemStyle: {
//                     color: new echarts.graphic.LinearGradient(
//                         0, 0, 0, 1,
//                         [
//                             {offset: 0, color: '#2378f7'},
//                             {offset: 0.7, color: '#2378f7'},
//                             {offset: 1, color: '#83bff6'}
//                         ]
//                     )
//                 }
//             },
//             data: data
//         }
//     ]
// };

// // Enable data zoom when user click bar.
// var zoomSize = 6;
// myChart.on('click', function (params) {
//     console.log(dataAxis[Math.max(params.dataIndex - zoomSize / 2, 0)]);
//     myChart.dispatchAction({
//         type: 'dataZoom',
//         startValue: dataAxis[Math.max(params.dataIndex - zoomSize / 2, 0)],
//         endValue: dataAxis[Math.min(params.dataIndex + zoomSize / 2, data.length - 1)]
//     });
// });

// option && myChart.setOption(option);

  },
  data () {
    return {
      location: '北京',
      keyword: '百度'
    }
  }
}
</script>
<style scoped>
    .map{
        width: 800px;
        height: 300px;
    }
</style>